/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import I18nProvider, {I18nContext} from '@adobe/adobe-intl-react';
import PropTypes from 'prop-types';
import React from 'react';
import Wait from '@react/react-spectrum/Wait';
import * as waitLocaleData from './__localization__/ShellWait';

const I18nShellWait = ({centered, localizationStrings, size, ...otherProps}) => {
  const {formatMessage} = React.useContext(I18nContext);
  return (
    <Wait
      aria-label={formatMessage({
        defaultMessage: localizationStrings['shellWaitLabel'],
        messageId: 'shellWaitLabel'
      }) || 'Loading'}
      aria-live="polite"
      centered={centered || true}
      size={size || 'L'}
      {...otherProps} />
  );
};

const ShellWait = ({locale, ...otherProps}) => {
  return (
    <I18nProvider locale={locale} localeData={waitLocaleData}>
      <I18nShellWait {...otherProps} />
    </I18nProvider>
  );
};

ShellWait.defaultProps = {
  localizationStrings: {
    shellWaitLabel: 'Loading'
  }
};

ShellWait.propTypes = {
  localizationStrings: PropTypes.shape({
    /** aria-label for Wait spinner component */
    shellWaitLabel: PropTypes.string
  })
};

export default React.memo(ShellWait);
